import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const useTable = ({ totalItems }: { totalItems?: number }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const handleSelectRow = (id: string) => {
        setSearchParams(params => {
            const parameters = new URLSearchParams(params)
            const currentSelected = parameters.get('selected_ids')
            const convertToArray = currentSelected?.split(',').filter(Boolean) || []

            if (convertToArray.includes(id)) {
                const updated = convertToArray.filter(item => item !== id)
                if (updated.length > 0) {
                    parameters.set('selected_ids', updated.join(','))
                } else {
                    parameters.delete('selected_ids')
                }
            } else {
                convertToArray.push(id)
                parameters.set('selected_ids', convertToArray.join(','))
            }

            return parameters
        })
    }
    const handleUnselectRow = (id: string) => {
        setSearchParams(params => {
            const parameters = new URLSearchParams(params)
            const currentSelected = parameters.get('remove_ids')
            const convertToArray = currentSelected?.split(',').filter(Boolean) || []

            if (convertToArray.includes(id)) {
                const updated = convertToArray.filter(item => item !== id)
                if (updated.length > 0) {
                    parameters.set('remove_ids', updated.join(','))
                } else {
                    parameters.delete('remove_ids')
                }
            } else {
                convertToArray.push(id)
                parameters.set('remove_ids', convertToArray.join(','))
            }

            return parameters
        })
    }
    const handleSelectAllInPage = (ids: string[]) => {
        setSearchParams(params => {
            const parameters = new URLSearchParams(params)
            parameters.delete('selected_ids')
            parameters.delete('remove_ids')
            const currentSelected = parameters.get('selected_ids')?.split(',').filter(Boolean) || []

            ids.forEach(id => {
                if (!currentSelected.includes(id)) {
                    currentSelected.push(id)
                }
            })

            parameters.set('selected_ids', currentSelected.join(','))
            return parameters
        })
    }
    const handleSelectAll = () => {
        setSearchParams(params => {
            const parameters = new URLSearchParams(params)
            parameters.delete('selected_ids')
            parameters.delete('remove_ids')
            parameters.set('selected_ids', 'all')
            return parameters
        })
    }
    const handleDeselectAll = () => {
        setSearchParams(params => {
            const parameters = new URLSearchParams(params)
            parameters.delete('selected_ids')
            return parameters
        })
    }
    const isAllSelected = useMemo(() => {
        return searchParams.get('selected_ids') === 'all';
    }, [searchParams])

    const unselectedIds = useMemo(() => {
        const unselected = searchParams.get('remove_ids')
        if (unselected) {
            return unselected.split(',').map((id) => id.trim());
        }
        return [];
    }, [searchParams])
    const selectedRows = useMemo(() => {
        const selectedIds = searchParams.get('selected_ids');
        if (selectedIds) {
            return selectedIds.split(',').map((id) => id.trim());
        }
        return [];
    }, [searchParams])
    const totalSelected = useMemo(() => {
        const selectedIds = searchParams.get('selected_ids');
        if (selectedIds === 'all') {
            return totalItems || 0;
        }
        if (selectedIds) {
            const selectedArray = selectedIds.split(',').map((id) => id.trim());
            return selectedArray.length;
        }
        return 0;
    }, [searchParams])
    const totalUnselected = useMemo(() => {
        const unselectedIds = searchParams.get('remove_ids');
        if (unselectedIds) {
            const unselectedArray = unselectedIds.split(',').map((id) => id.trim());
            return unselectedArray.length;
        }
        return 0;
    }, [searchParams])
    const totalItemsSelecteds = useMemo(() => totalSelected - totalUnselected, [totalUnselected, totalSelected])
    return { selectedRows, unselectedIds, totalItemsSelecteds, isAllSelected, handleSelectAll, handleSelectAllInPage, handleSelectRow, handleDeselectAll, handleUnselectRow }
};